import { enUS } from 'date-fns/locale';
import { format, utcToZonedTime } from 'date-fns-tz';

/**
 * ! this might look goofy, since we're converting UTC to UTC, but it's basically to preserve
 * ! the date object as it was originally sent by the backend
 * - If we do UTC to local time, then there will be conversions that we may not expect
 * * best used when dealing with simple dates (like date of birth)
 *
 * This should be used for simple dates without a timestamp (e.g.,
 * "1990-10-01"). The Date constructor automatically converts a date to the
 * local timezone ("1990-10-01" becomes "1990-10-01T00:00:00.000Z"). When the
 * date is then formatted, it appears one day earlier ("09/30/1990").
 */
export function parseDate(date: string) {
  return utcToZonedTime(date, 'UTC');
}

export function parseAndFormatDate(
  date: string | undefined | null,
  _format = 'P',
  locale: Locale = enUS,
) {
  return date ? format(parseDate(date), _format, { locale }) : '';
}
